module.exports = __webpack_public_path__ + "media/images/favicon/favicon-e531671e0ecd37a75ea65a6c74679c93.ico";